export class GeneralExaminationModel
{
  patientcode = '' ;
  examdate =  '2022-01-01';
  gcondition = 'Good' ;
  peform = '0' ;
  weight = '0' ;
  height = '0' ;
  s_a = '0' ;
  acs_a = '0' ;
  temp = '37' ;
  pulse = '80' ;
  rhythm = 'Regular' ;
  rhythms = '' ;
  b_p = '120/80' ;
  respirationrate = '' ;
  headneck = 'Normal' ;
  hncolour = 'Normal' ;
  hnveins = 'Normal' ;
  hnthyroid = 'Normal' ;
  hnoralcavity = 'Normal' ;
  hnswelling = '' ;
  hnswellingsite = '' ;
  hnswellingsize = '' ;
  hncons = 'Soft' ;
  hnmob = 'Fixed' ;
  hnmention = '' ;
  upperlimbs = 'Normal' ;
  ulrswelling = '' ;
  ulrswellsite = '' ;
  ulrswellsize = '' ;
  ulrcon = 'Soft' ;
  ulrmob = '' ;
  ulroedema = '' ;
  ulrothers = '' ;
  ullswelling = '' ;
  ullswellsite = '' ;
  ullswellsize = '' ;
  ullcon = 'Soft' ;
  ullmob = '' ;
  ulloedema = '' ;
  ullothers = '' ;
  lowerlimbs = 'Normal' ;
  llrswelling = '' ;
  llrswellsite = '' ;
  llrswellsize = '' ;
  llrcon = 'Soft' ;
  llrmob = '' ;
  llroedema = '' ;
  llrothers = '' ;
  lllswelling = '' ;
  lllswellsite = '' ;
  lllswellsize = '' ;
  lllcon = 'Soft' ;
  lllmob = '' ;
  llloedema = '' ;
  lllothers = '' ;
  brest = 'Normal' ;
  bright = 'Normal' ;
  bleft = 'Normal' ;
  chest = 'Normal' ;
  chestspes = '' ;
  abdomen = 'Normal' ;
  abdliver = '' ;
  abdspleen = '' ;
  abdascities = '' ;
  abdothers = '' ;
  neurological = 'Normal' ;
  neurspec = '' ;
  lymphadenopathy = 'Normal' ;
  rcervical = '' ;
  rcervicallevel = '' ;
  rcervicalsize = '' ;
  rcervicalcons = '' ;
  rcervicalmob = '' ;
  lcervical = '' ;
  lcervicallevel = '' ;
  lcervicalsize = '' ;
  lcervicalcons = '' ;
  lcervicalmob = '' ;
  raxillary = '' ;
  raxillarylevel = '' ;
  raxillarysize = '' ;
  raxillarycons = '' ;
  raxillarymob = '' ;
  laxillary = '' ;
  laxillarylevel = '' ;
  laxillarysize = '' ;
  laxillarycons = '' ;
  laxillarymob = '' ;
  ringuinal = '' ;
  ringuinalsite = '' ;
  ringuinalsize = '' ;
  ringuinalcons = '' ;
  ringuinalmob = '' ;
  linguinal = '' ;
  linguinalsite = '' ;
  linguinalsize = '' ;
  linguinalcons = '' ;
  linguinalmob = '' ;
  hnnotes = '' ;
  ulnotes = '' ;
  llnotes = '' ;
  brestnotes = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2022-01-01' ;

}
